import { Routes, Route, Navigate } from 'react-router-dom';
import { CONSTANTS } from 'src/commons';
import MainLayout from 'src/components/MainLayout';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import Register from 'src/pages/Register';
import { connect } from 'react-redux';
import { startLoading, stopLoading } from 'src/redux/actions';
import Loader from 'src/components/Loader';

const PublicRoutes = ({ loading, startLoading, stopLoading }) => {
  const PUBLIC_ROUTES = CONSTANTS.ROUTES.PUBLIC_ROUTES;

  return (
    <MainLayout>
      {loading ? <Loader /> : null}
      <Routes>
        <Route
          path={PUBLIC_ROUTES.LOGIN}
          element={
            <Login startLoading={startLoading} stopLoading={stopLoading} />
          }
        />
        <Route path={PUBLIC_ROUTES.NOT_FOUND} component={NotFound} />
        <Route
          path={PUBLIC_ROUTES.REGISTER}
          element={
            <Register startLoading={startLoading} stopLoading={stopLoading} />
          }
        />
        <Route path={"*"} element={<Navigate path={'/'} to={PUBLIC_ROUTES.LOGIN} exact />}/>
        <Route path={"*"} element={<Navigate to={PUBLIC_ROUTES.LOGIN} />}/>

      </Routes>
    </MainLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.loader.loading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => dispatch(startLoading()),
    stopLoading: () => dispatch(stopLoading())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PublicRoutes);
